import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5aa8a2fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "drag-icon"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "open_with", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "product-panel-image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-column w-100" }
const _hoisted_7 = { class: "d-flex justify-content-between" }
const _hoisted_8 = { class: "product-panel-text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas product-panel-icon" }, "delete", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "product-panel-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-panel", { 'drop-target': _ctx.isDropTarget, 'not-in-catalog': !_ctx.isInCatalog }])
  }, [
    (_ctx.isDraggableAndDeletable)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isInCatalog)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.product.main_image_url,
            alt: "",
            style: {"width":"48px","height":"48px"}
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.codeToShow), 1),
        (_ctx.isDraggableAndDeletable)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-danger product-panel-button",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteProduct && _ctx.deleteProduct(...args)))
            }, _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.isInCatalog ? _ctx.productName : _ctx.$t('notInYourCatalog')), 1)
    ])
  ], 2))
}